// import Vue from "vue/types/index";
import peerstore from '../whalewisdom/store'

window.whalewisdom.Filer = {
  current_sector_index: 0,
  show_combined: true,
  sectorInterval: null,
  mc_concentration_chart: null,
  schedule13_table_initialized: false,
  peer_groups_init: false,
  columns: [],
  init: function () {
    jQuery('.cmd-refresh').click(whalewisdom.Filer.refresh)
    jQuery('#cmd-export').click(whalewisdom.Filer.export_to_excel)
    jQuery('#cmd-export-tsv').click(whalewisdom.Filer.export_to_excel_tsv)
    jQuery('#cmd-export-xlsx').click(whalewisdom.Filer.export_to_excel_xlsx)

    jQuery(document).on('shown.bs.tab', 'a[data-toggle="tab"]', function (e) { // on tab selection event
      jQuery('#chart_container').each(function () { // target each element with the .contains-chart class
        var chart = window.whalewisdom.Filer.metrics_chart// Highcharts.chart(this, { /*Highcharts options*/ });//jQuery(this).highcharts(); // target the chart itself
        chart.reflow() // reflow that chart
        if (whalewisdom.Filer.mc_concentration_chart) {
          whalewisdom.Filer.mc_concentration_chart.reflow()
        }
      })
    })

    jQuery('#cmd-combined-holders').click(whalewisdom.Filer.view_combined)
    jQuery('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
      //  e.target // activated tab
      //   e.relatedTarget // previous tab
      var hash = location.hash.replace('/', '').replace('#tab', '')
      if (hash != e.target.id.replace('/', '')) {
        location.hash = '#tab' + e.target.id.replace('/', '')
      }
      if (e.target.id == 'holdings_tab_link') {
        var width = jQuery('#holdings-by-quarter').width()
        // jQuery("#current_holdings_table").setGridWidth(width - 7);
      } else if (e.target.id == 'mutual_fund_tab_link') {
        var width = jQuery('#mutual_fund_series_container').width()
        jQuery('#mf_holdings_table').setGridWidth(width)
      } else if (e.target.id == 'schedule13d_tab_link') {
        var width = jQuery('#sch13_wrapper').width()
        if (!whalewisdom.Filer.schedule13_table_initialized) {
          whalewisdom.Filer.setup_13d_table()
          whalewisdom.Filer.schedule13_table_initialized = true
        }
        //                jQuery("#schedule13d_table").setGridWidth(width);
      }
      else if (e.target.id == 'intl_tab_link') {
        var width = jQuery('#intl_wrapper').width()
        if (!whalewisdom.Filer.intl_table_initialized) {
          whalewisdom.Filer.setup_intl_table()
          whalewisdom.Filer.intl_table_initialized = true
        }
        //                jQuery("#schedule13d_table").setGridWidth(width);
      }
    })

    jQuery('.filter-change').change(function (e) {
      // $(this).addClass('active');
      var justselectedval = $(this).val()
      //  if (d==6){
      // deselect all others
      var filters = jQuery('.filter-change')
      filters.filter(':checked').each(function () {
        var d = $(this).val()
        if (justselectedval != d) {
          if (justselectedval == '6') {
            $(this).prop('checked', false)
            $(this).parent().removeClass('active')
          } else if (d == '6') {
            $(this).prop('checked', false)
            $(this).parent().removeClass('active')
          }

          // unselect
        }
      })
      // }
      $('.cmd-refresh ').click()
    })

    jQuery('#lnk_holdings_tab').click(function () {
      jQuery('#filer-nav li:eq(1) a').tab('show')
      var width = jQuery('#filer-nav-content').width()
      //  jQuery("#current_holdings_table").setGridWidth(width);
    })
    /*    $('#sector_chart_back').click(whalewisdom.Filer.previous_sector_chart);
        $('#sector_chart_play').click(whalewisdom.Filer.play_sector_chart);
        $('#sector_chart_pause').click(whalewisdom.Filer.pause_sector_chart);
        $('#sector_chart_forward').click(whalewisdom.Filer.next_sector_chart); */

    jQuery(window).bind('resize', function () {
      // if (jQuery.browser.msie  && parseInt(jQuery.browser.version, 10) <= 7) {
      // jQuery("#current_holdings_table").setGridWidth(800);
      //                     return;
      //                }
      var width = jQuery('#filer-nav-content').width()
      // if (width<700){
      //    jQuery("#current_holdings_table").bootstrapTable('resetView');
      // }
      // jQuery("#current_holdings_table").jqGrid("setGridWidth",width);
    }).trigger('resize')

    //  jQuery('#quarter_one').val(whalewisdom.Filer.current_quarter_id);
    jQuery('#quarter_one').change(whalewisdom.Filer.update_query_url)
    var width = jQuery('#filer-nav-content').width()
    var hide_column = width < 0
    whalewisdom.Filer.columns = [
      {
        field: 'symbol',
        index: 'symbol',
        title: 'Stock',
        sortable: true,
        // width: 75,
        formatter: whalewisdom.Filer.symbol_formatter
      },
      {
        field: 'id',
        index: 'symbol',
        title: '',
        // width: 40,
        formatter: whalewisdom.Filer.history_formatter
      },
      {
        field: 'sector',
        sortable: true,
        index: 'sector',
        title: 'Sector',
        visible: !hide_column
      },
      {
        field: 'current_shares',
        sortable: true,
        index: 'current_shares',
        title: 'Shares Held<br/>or Principal Amt',
        firstsortorder: 'desc',
        formatter: whalewisdom.Filer.format_number
      },
      {
        field: 'current_mv',
        sortable: true,
        index: 'current_mv',
        title: 'Market Value',
        firstsortorder: 'desc',
        formatter: whalewisdom.Filer.format_money
      },
      {
        field: 'current_percent_of_portfolio',
        title: '% of<br/>Portfolio',
        sortable: true,
        firstsortorder: 'desc',
        index: 'current_percent_of_portfolio',
        formatter: whalewisdom.Filer.format_percent
      },
      {
        field: 'previous_percent_of_portfolio',
        title: 'Previous<br/>% of Portfolio',
        sortable: true,
        firstsortorder: 'desc',
        index: 'previous_percent_of_portfolio',
        formatter: whalewisdom.Filer.format_percent
      },
      {
        field: 'current_ranking',
        title: 'Rank',
        sortable: true,
        firstsortorder: 'desc',
        index: 'current_ranking',
        //   width: 75,
        formatter: whalewisdom.Filer.ranking_formatter
      },
      {
        field: 'shares_change',
        title: 'Change in<br/>Shares',
        sortable: true,
        firstsortorder: 'desc',
        index: 'shares_change',
        formatter: whalewisdom.Filer.change_formatter,
        visible: !hide_column
      },
      {
        field: 'percent_shares_change',
        title: '% Change',
        sortable: true,
        firstsortorder: 'desc',
        //   width: 95,
        index: 'percent_shares_change',
        formatter: whalewisdom.Filer.percent_change_formatter
      },
      {
        field: 'percent_ownership',
        title: '% Ownership',
        sortable: true,
        index: 'percent_ownership',
        //  width: 120,
        formatter: whalewisdom.Filer.ownership_formatter,
        visible: !hide_column
      },
      {
        field: 'quarter_first_owned',
        title: 'Qtr 1st<br/>Owned',
        sortable: true,
        index: 'quarter_id_owned',
        // width: 75,
        visible: !hide_column
      },
      {
        field: 'avg_price',
        sortable: false,
        index: 'avg_price',
        title: 'Estimated<br/>Avg Price Paid',
        firstsortorder: 'desc',
        formatter: whalewisdom.Filer.format_percent
      },
      {
        field: 'quarter_end_price',
        sortable: false,
        index: 'avg_price',
        title: 'Quarter End Price',
        firstsortorder: 'desc',
        formatter: whalewisdom.Filer.format_percent
      },
      {
        field: 'recent_price',
        sortable: false,
        index: 'recent_price',
        title: 'Recent Price',
        firstsortorder: 'desc',
        formatter: whalewisdom.Filer.format_percent
      }//,
      // {name: 'stock_id', index: 'stock_id', hidden: true},
      // {name: 'security_type', index: 'security_type', hidden: true}
    ]
    whalewisdom.Filer.columns.push({ field: 'source_type', title: 'Source', sortable: true, index: 'source_type', visible: whalewisdom.Filer.show_combined })
    whalewisdom.Filer.columns.push({ field: 'source_date', title: 'Source Date', sortable: true, index: 'source_date', visible: whalewisdom.Filer.show_combined })
    whalewisdom.Filer.columns.push({ field: 'filing_date', title: 'Date Reported', sortable: true, index: 'filing_date', visible: whalewisdom.Filer.show_combined })
    /*  if (whalewisdom.Filer.show_combined){
            jQuery('#cmd-combined-holders').html('Show Historical 13F Holdings Instead');
            $('#combined-heading').css('display','block');
          //  $('#quarter_one').css('display','none');
          //  $('#qtr-1-label').css('display','none');
        } */
    var c = whalewisdom.Filer.columns
    var names = ['Stock', '', 'Sector', 'Shares Held<br/>or Principal Amt', 'Market Value', '% of<br/>Portfolio', 'Previous<br/>% of Portfolio', 'Rank', 'Change in<br/>Shares',
      '% Change', '% Ownership', 'Qtr 1st<br/>Owned', 'Source', 'Source Date', 'Date Reported']
    if (!jQuery('.menu-trigger .navbar-toggle .collapsed').is(':visible')) {
      /*     c[4].hidden = true;
             c[5].hidden = true;
             c[7].hidden = true; */
    }
    $('#current_holdings_table').bootstrapTable({
      url: whalewisdom.Filer.build_url(),
      sidePagination: 'server',
      pagination: true,
      paginationVAlign: 'both',
      sortName: 'current_mv',
      onLoadError: function (arg1, arg2) {
        $('#current_holdings_table').bootstrapTable('updateFormatText', 'NoMatches', arg2.responseText)
      },
      sortOrder: 'desc',
      pageSize: 25,
      rowStyle: function (row, index) {
        return {
          css: { 'padding': '8px', 'height': '37px' }
        }
      },
      //  mobileResponsive:true,
      checkOnInit: true,
      toggle: 'table',
      showColumns: true,
      pageList: [10, 25, 50],
      stickyHeader: true,
      showJumpto: true,
      cookie:true,
      cookieIdTable:"filer_holdings",
      cookieExpire:'1y',
      totalField: 'records',
      columns: c
    })

    var offloads = jQuery('div.offload')
    for (var i = 0; i < offloads.length; i++) {
      var off = jQuery(offloads[i])
      var url = off.attr('data-web-call')
      jQuery.ajax({
        url: url,
        context: jQuery(offloads[i]),
        success: function (data) {
          jQuery(this).html(data)
          if (jQuery('#form_4_table').length > 0) {
            var count = jQuery('#form_4_table tr').length
            if (count > 0) count -= 1
            jQuery('#form4_link_a').html('Insider (' + count + ')')
          }
        }
      })
    }

    whalewisdom.Filer.draw_charts()

    setTimeout(function () {
      var hash = location.hash.replace('/', '').replace('#tab', '')
      if (hash != '') {
        try {
          $('#' + hash)[0].click()
        } catch (err) {

        }
      }
    }, 1)

    window.whalewisdom.Filer.setup_metric_chart()
    window.whalewisdom.Filer.build_column_chooser()
    if ($('#n_cen_container').length > 0) {
      $('#n_cen_link').css('display', '')
      $('#n_cen_li').css('display', '')
      $('#n_cen').css('display', '')
    }
  },
  ownership_formatter: function (cellvalue, record) {
    var cell = record.percent_ownership
    if (!cell) {
      cell = 'No Data'
    } else if (cell == 'No Data' || cell == 'N/A') {

    } else {
      cell = parseFloat(record.percent_ownership).toFixed(4) + '%'
    }

    return cell
  },
  draw_charts: function () {
    if ($('#sector_chart').length > 0) {
      whalewisdom.Filer.load_sector_chart('sector_chart')
    }

    if ((typeof ww_13fperf_data !== 'undefined' || typeof mv_data !== 'undefined')) {
      whalewisdom.Filer.setup_13f_chart()
    }
    if (typeof mc_concentration !== 'undefined') {
      whalewisdom.Filer.setup_mc_concentration_chart()
    }
  },
  setup_mc_concentration_chart: function () {
    var chartdata = []
    for (var i = 0; i < mc_concentration.length; i++) {
      var mc = mc_concentration[i]
      chartdata.push({ name: mc.description, y: mc.value })
    }
    whalewisdom.Filer.mc_concentration_chart = Highcharts.chart('mc_concentration_chart', {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
      },
      credits: {
        enabled: false
      },
      title: {
        text: 'Concentration by Stock Market Cap'
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %',
            style: {
              color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
            }
          }
        }
      },
      series: [{
        name: '% Concentration',
        colorByPoint: true,
        data: chartdata
      }]
    })
  },

  /*  draw_sector_chart: function () {
        var all_data = ww_all_sectors;
        var keys = Object.keys(all_data);
        var data = [];
        var colors = [];
        var chart_data = all_data[keys[whalewisdom.Filer.current_sector_index]];
        $('#sector_description').html(keys[whalewisdom.Filer.current_sector_index]);
        var sector_colors = {
            'CONSUMER DISCRETIONARY': '#ffbb78',
            'CONSUMER GOODS': '#1f77b4',
            'CONSUMER STAPLES': '#aec7e8',
            'ENERGY': '#ff7f0e',
            'FINANCE': '#2ca02c',
            'HEALTH CARE': '#98df8a',
            'INDUSTRIALS': '#d62728',
            'INFORMATION TECHNOLOGY': '#ff9896',
            'MATERIALS': '#9467bd',
            'MUTUAL FUND': '#c5b0d5',
            'SERVICES': '#8c564b',
            'TRANSPORTS': '#009999',
            'UTILITIES & TELECOMMUNICATIONS': '#33ccff',
            'REAL ESTATE': '#9999ff',
            'OTHER': '#ffcc99'
        }
        for (var i = 0; i < chart_data.length; i++) {
            var row = chart_data[i];
            var obj = {label: row.name, value: parseInt(row.mv)};
            var color = sector_colors[row.name];
            if (color) {
                obj.color = color;
                colors.push(color);
            }

            data.push(obj);
        }
        var chart = nv.models.pieChart()
                .x(function (d) {
                    return d.label;
                })
                .y(function (d) {
                    return d.value;
                })
                // .color(colors)
                .showLabels(true)     //Display pie labels
                .labelThreshold(.05)  //Configure the minimum slice size for labels to show up
                .labelType("percent") //Configure what type of data to show in the label. Can be "key", "value" or "percent"
                .donut(true)          //Turn on Donut mode. Makes pie chart look tasty!
                .donutRatio(0.35)     //Configure how big you want the donut hole size to be.
            ;

        d3.select("#sector_chart svg")
            .datum(data)
            .transition().duration(350)
            .call(chart);
    }, */
  /*  pause_sector_chart: function () {
        if (whalewisdom.Filer.sectorInterval)
            clearInterval(whalewisdom.Filer.sectorInterval);
        whalewisdom.Filer.sectorInterval = null;
    },
    next_sector_chart: function () {
        var all_data = ww_all_sectors;
        var keys = Object.keys(all_data);
        var play = false;
        if (whalewisdom.Filer.sectorInterval)
            play = true;
        whalewisdom.Filer.current_sector_index += 1;
        if (whalewisdom.Filer.current_sector_index >= keys.length)
            whalewisdom.Filer.current_sector_index = 0;
        if (play)
            whalewisdom.Filer.play_sector_chart();
        else
            whalewisdom.Filer.draw_sector_chart();
    },
    previous_sector_chart: function () {
        var all_data = ww_all_sectors;
        var keys = Object.keys(all_data);
        var play = false;
        if (whalewisdom.Filer.sectorInterval)
            play = true;
        whalewisdom.Filer.current_sector_index -= 1;
        if (whalewisdom.Filer.current_sector_index < 0)
            whalewisdom.Filer.current_sector_index = keys.length - 1;
        if (play)
            whalewisdom.Filer.play_sector_chart();
        else
            whalewisdom.Filer.draw_sector_chart();
    },
    play_sector_chart: function () {
        var all_data = ww_all_sectors;
        var keys = Object.keys(all_data);
        whalewisdom.Filer.sectorInterval = setInterval(function () {
                whalewisdom.Filer.draw_sector_chart();
                whalewisdom.Filer.current_sector_index += 1;
                if (whalewisdom.Filer.current_sector_index >= keys.length)
                    whalewisdom.Filer.current_sector_index = 0;
            },
            1500);
    }, */
  setup_13f_chart: function () {
    if (typeof ww_13fperf_data !== 'undefined') {
      var chart_data = ww_13fperf_data
      var cdata = []

      for (var i = 0; i < ww_13fperf_data.length; i++) {
        var p = ww_13fperf_data[i]
        var data = []
        var tempdata = []
        var last = null
        tempdata = p['monthly_entries']
        var start = p['starting_balance']
        var offset = 0
        if (!whalewisdom.Utilities.isSubscriber() && tempdata.length > 24) {
          tempdata = tempdata.slice(tempdata.length - 24)
          start = tempdata[0][2]
        }
        data = tempdata
        var obj = {
          name: i == 0 ? 'Whale' : p.description,
          data: [],
          area: (i == 0 ? true : true),
          color: (i == 0 ? '#57aea5' : '#111')
        }
        var compound = 0

        for (var j = 0; j < data.length - 1; j++) {
          var entry = data[j]
          var d3data = { x: null, y: null }
          var s = entry[0]
          if (s.length == 4) { s = new Date(parseInt(s), 1, 1) } else {
            var darray = s.split('-')
            s = new Date(darray[0], parseInt(darray[1]) - 1, darray[2])
          }
          d3data.x = s// .getTime();
          compound = ((entry[2] - start) / start) * 1.0
          d3data.y = compound

          obj.data.push(d3data)
        }
        cdata.push(obj)
      }
      Highcharts.chart('perf_13f_graph', {
        chart: {
          type: 'area',
          backgroundColor: '#ebeff1'
        },
        title: {
          text: ''
        },
        subtitle: {
        },
        xAxis: {
          allowDecimals: false,
          labels: {
            formatter: function () {
              var d = new Date(this.value)

              return d.getFullYear() + '-' + (d.getMonth() + 1)// d3.time.format('%Y-%m')(new Date(d));
              // return this.value; // clean, unformatted number for year
            }
          }
        },
        yAxis: {
          title: {
            text: ''
          },
          labels: {
            formatter: function () {
              return this.value * 100.0 + '%'
            }
          }
        },
        tooltip: {
          shared: true,
          formatter: function () {
            var points = this.points
            var pointsLength = points.length
            var d = new Date(points[0].key)

            var tooltipMarkup = pointsLength ? '<span style="font-size: 10px">' + d.getFullYear() + '-' + (d.getMonth() + 1) + '</span><br/>' : ''
            var index
            var y_value_kwh

            for (index = 0; index < pointsLength; index += 1) {
              y_value_kwh = (points[index].y * 100.0).toFixed(2)

              tooltipMarkup += '<span style="color:' + points[index].series.color + '">\u25CF</span> ' +
                                points[index].series.name + ': <b>' + y_value_kwh + '%</b><br/>'
            }

            return tooltipMarkup
          }
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          area: {
            // pointStart: 1940,
            marker: {
              enabled: false,
              symbol: 'circle',
              radius: 2,
              states: {
                hover: {
                  enabled: true
                }
              }
            }
          }
        },
        series: cdata
      })

      /*  var chart = nv.models.lineChart()
                    .margin({left: 100})  //Adjust chart margins to give the x-axis some breathing room.
                    .useInteractiveGuideline(true)  //We want nice looking tooltips and a guideline!
                    //     .transitionDuration(350)  //how fast do you want the lines to transition?
                    .showLegend(true)       //Show the legend, allowing users to turn on/off line series.
                    .showYAxis(true)        //Show the y-axis
                    .showXAxis(true)        //Show the x-axis
                ;

            chart.xAxis
                .tickFormat(function (d) {
                    return d3.time.format('%Y-%m')(new Date(d))
                });

            chart.yAxis     //Chart y-axis settings
                .axisLabel('Perf')
                .tickFormat(d3.format('.2%'));

            d3.select('#perf_13f_graph svg')    //Select the <svg> element you want to render the chart in.
                .datum(cdata)         //Populate the <svg> element with chart data...
                .call(chart);          //Finally, render the chart!

            //Update the chart when window resizes.
            nv.utils.windowResize(function () {
                chart.update()
            }); */
    }
  },
  export_to_excel: function () {
    var id = parseInt($('#quarter_one').val())
    var allowed = false
    if (id > 0 && (whalewisdom.Filer.current_quarter_id - 9) > id) { allowed = false }
    if (allowed && !whalewisdom.Utilities.isLoggedIn()) {
      whalewisdom.Utilities.show_alert('Please Log In First',
        'A premium account is now required to download this data.  Please create an account or log into your existing account first. ' +
                'Premium subscribers may download ' +
                "data as far back as 2001.   <a href='/transactions-sample.csv'>Download a sample file.</a>")
    /*whalewisdom.Utilities.show_alert('Please Log In First',
        'Please create an account or log into your existing account first. The free account allows you to ' +
                'download data for the past two years.  Premium subscribers may download ' +
                "data as far back as 2001.   <a href='/transactions-sample.csv'>Download a sample file.</a>")   */
      return
    }

    if (!allowed && !whalewisdom.Utilities.isSubscriber()) {
      whalewisdom.Utilities.show_alert('Subscription Required',
        "This feature requires a subscription to use. <a href='/transactions-sample.csv'>Download a sample file.</a>")
      return
    }
    var url = whalewisdom.Filer.build_url().replace('/filer/holdings', '/filer/holdings_csv')
    window.location = url
  },
  export_to_excel_tsv: function () {
    var id = parseInt($('#quarter_one').val())
    var allowed = false
    if (id > 0 && (whalewisdom.Filer.current_quarter_id - 9) > id) { allowed = false }
    if (allowed && !whalewisdom.Utilities.isLoggedIn()) {
       whalewisdom.Utilities.show_alert('Please Log In First',
              'A premium account is now required to download this data.  Please create an account or log into your existing account first. ' +
                      'Premium subscribers may download ' +
                      "data as far back as 2001.   <a href='/filer-transactions-sample.tsv'>Download a sample file.</a>")
      return
    }
    if (!allowed && !whalewisdom.Utilities.isSubscriber()) {
      whalewisdom.Utilities.show_alert('Subscription Required',
        "This feature requires a subscription to use. <a href='/filer-transactions-sample.tsv'>Download a sample file.</a>")
      return
    }
    var url = whalewisdom.Filer.build_url().replace('/filer/holdings', '/filer/holdings_tsv')
    window.location = url
  },
  export_to_excel_xlsx: function () {
    var id = parseInt($('#quarter_one').val())
    var allowed = false
    if (id > 0 && (whalewisdom.Filer.current_quarter_id - 9) > id) { allowed = false }
    if (allowed && !whalewisdom.Utilities.isLoggedIn()) {
       whalewisdom.Utilities.show_alert('Please Log In First',
              'A premium account is now required to download this data.  Please create an account or log into your existing account first. ' +
                      'Premium subscribers may download ' +
                      "data as far back as 2001.   <a href='/filer-transactions-sample.xlsx'>Download a sample file.</a>")
      return
    }
    if (!allowed && !whalewisdom.Utilities.isSubscriber()) {
      whalewisdom.Utilities.show_alert('Subscription Required',
        "This feature requires a subscription to use. <a href='/filer-transactions-sample.xlsx'>Download a sample file.</a>")
      return
    }
    var url = whalewisdom.Filer.build_url().replace('/filer/holdings', '/filer/holdings_xlsx')
    window.location = url
  },
  format_money: function (cellvalue, record) {
    if (!cellvalue || isNaN(cellvalue)) { return '' }
    return numbro(cellvalue).formatCurrency({ thousandSeparated: true, mantissa: 0 })// ('($0,0a');
  },
  format_number: function (cellvalue, record) {
    if (!cellvalue || isNaN(cellvalue)) { return '' }
    return numbro(cellvalue).format({ thousandSeparated: true, negative: 'parenthesis' })
  },
  format_percent: function (cellvalue, record) {
    if (!cellvalue || isNaN(cellvalue)) { return '' }
    return numbro(cellvalue).format('0.00')
  },
  symbol_formatter: function (cellvalue, record) {
    var url = window.location.href
    var href = null
    if (url.indexOf('#') >= 0) {
      url = url.substring(0, url.indexOf('#'))
    }

    href = url.split('/')
    var cell = '<a href="/stock/' + record.permalink + '" title="' + record.name + '">' + record.symbol.toUpperCase()

    cell += '</a>'
    if (record.security_type == 'PRN') { cell += "<span style='font-weight:bold;' title='PRN - principal amount on convertible debt securities'>(" + record.security_type + ')</span>' } else if (record.security_type != 'SH') { cell += "<span style='font-weight:bold;'>(" + record.security_type + ')</span>' }
    return cell
  },
  history_formatter: function (cellvalue, record) {
    var url = window.location.href
    var href = null
    if (url.indexOf('#') >= 0) {
      url = url.substring(0, url.indexOf('#'))
    }

    href = url.split('/')
    var cell = '<a title="View Filer Ownership History" alt="View Filer Ownership History" class="history-link" href="' +
            '/filer/stock_history/' + href[href.length - 1] + '/' +
            record.permalink + '"></a>'

    return cell
  },
  ranking_formatter: function (cellvalue, record) {
    var cell = record.current_ranking
    if (record.current_ranking === 999999 && (!record.current_shares || record.current_shares==0)) { cell = 'Sold All' }
    else if (record.current_ranking===999999){
      cell='';
    }

    return cell
  },
  change_formatter: function (cellvalue, record) {
    var c = ''
    var desc = Math.abs(record.shares_change)
    desc = whalewisdom.Utilities.round_currency(desc)
    if (!record.shares_change || record.shares_change == 0) {
      desc = 'No Change'
    } else if (record.shares_change < 0) {
      c = 'decreasing'
    } else {
      c = 'increasing'
    }
    return '<span class="' + c + '">' + desc + '</span>'
  },
  percent_change_formatter: function (cellvalue, record) {
    var c = ''
    var desc = ''
    // var desc = Math.abs(record.shares_change);
    // desc = whalewisdom.Utilities.round_currency(desc);
    if (record.shares_change == 0) {
      desc = 0
    } else if (record.shares_change == record.current_shares) {
      desc = 'New'
    } else if (record.previous_shares && !record.current_shares) {
      desc = '-100'
    } else {
      var percent_change = ((record.current_shares - record.previous_shares) / (record.previous_shares)) * 100
      desc = whalewisdom.Utilities.round_currency(percent_change)
    }
    return '<span class="' + c + '">' + desc == 0 ? '' : desc == 'New' ? 'New' : (desc + '%') + '</span>'
  },
  global_percent_change_formatter: function (cellvalue, record) {
    var c = ''
    var desc = ''
    // var desc = Math.abs(record.shares_change);
    // desc = whalewisdom.Utilities.round_currency(desc);
    if (record.shares_change == 0) {
      desc = 0
    } else if (record.shares_change == record.current_shares) {
      desc = ''
    } else if (record.previous_shares && !record.current_shares) {
      desc = '-100'
    } else {
      var percent_change = ((record.current_shares - record.previous_shares) / (record.previous_shares)) * 100
      desc = whalewisdom.Utilities.round_currency(percent_change)
    }
    return '<span class="' + c + '">' + desc == 0 ? '' : desc == '' ? '' : (desc + '%') + '</span>'
  },
  refresh: function (e) {
    jQuery('#current_holdings_table').bootstrapTable('refresh', { url: whalewisdom.Filer.build_url() })// jqGrid('setGridParam', {url: whalewisdom.Filer.build_url()}).trigger("reloadGrid");
  },
  build_url: function () {
    return '/filer/holdings?id=' + whalewisdom.Filer.permalink + '&q1=' + jQuery('#quarter_one').val() +
            '&type_filter=' + whalewisdom.Filer.build_type_filter() +
            '&symbol=' + jQuery('#dt_stock_symbol').val() + '&change_filter=' +
            whalewisdom.Filer.build_change_filter() + '&minimum_ranking=' + jQuery('#minimum_ranking').val() +
            '&minimum_shares=' + jQuery('#minimum_shares').val() + '&is_etf=' + jQuery('#is_etf').val() +
            '&sc=' + whalewisdom.Filer.show_combined// +'&'
    // + whalewisdom.Utilities.get_timestamp_cache();
  },
  update_query_url: function () {
    if (jQuery('#quarter_one').val()<0){
      jQuery('#current_holdings_table').bootstrapTable('showColumn','recent_price')
    }
    else{
      jQuery('#current_holdings_table').bootstrapTable('hideColumn','recent_price')
    }
    jQuery('#current_holdings_table').bootstrapTable('refresh', { url: whalewisdom.Filer.build_url() })// jqGrid('setGridParam', {url: whalewisdom.Filer.build_url()});   //.trigger("reloadGrid");
  },
  build_type_filter: function () {
    var typeFilter = ''
    if (jQuery('#checkbuttonFieldShares').length > 0) {
      if (jQuery('#checkbuttonFieldShares')[0].checked) { typeFilter += jQuery('#checkbuttonFieldShares').val() + ',' }
      if (jQuery('#checkbuttonFieldCalls')[0].checked) { typeFilter += jQuery('#checkbuttonFieldCalls').val() + ',' }
      if (jQuery('#checkbuttonFieldPuts')[0].checked) { typeFilter += jQuery('#checkbuttonFieldPuts').val() + ',' }
      if (jQuery('#checkbuttonFieldPRNs')[0].checked) { typeFilter += jQuery('#checkbuttonFieldPRNs').val() }
    }
    return typeFilter
  },
  build_change_filter: function () {
    var outArr = []
    var filters = jQuery('.filter-change')
    filters.filter(':checked').each(function () {
      var d = $(this).val()
      if (d != 6) { outArr.push(jQuery(this).val()) }// val());
    })
    return outArr.join(',')
  },
  update_selected_tab: function (tab_name, callback) {
    /*   if (jQuery.browser.msie  && parseInt(jQuery.browser.version, 10) <= 7) {
         jQuery('.selected_tab').hide();
         jQuery('#' + tab_name + '_tab').show();
         jQuery('.selected_link').removeClass('selected_link');
         jQuery('#' + tab_name + '_link').addClass('selected_link');
         jQuery('.selected_tab').removeClass('selected_tab');
         jQuery('#' + tab_name + '_tab').addClass('selected_tab');
         if (callback)
         callback();
         return;
         } else {

         } */
    jQuery('.selected_tab').hide('fast', function () {
      jQuery('#' + tab_name + '_tab').show('normal', function () {
        jQuery('.selected_link').removeClass('selected_link')
        jQuery('#' + tab_name + '_link').addClass('selected_link')
        jQuery('.selected_tab').removeClass('selected_tab')
        jQuery('#' + tab_name + '_tab').addClass('selected_tab')
        if (callback) { callback() }
      })
    })
  },
  sch13_link_formatter: function (cellvalue, record) {
    var href = window.location.href.split('/')
    var cell = '<a href="/filing/' + record.permalink + '" title="' + record.name + '">' + record.form_type + '</a>'
    return cell
  },
  setup_13d_table: function () {
    if (whalewisdom.Filer.filer_id == undefined) {
      jQuery('#schedule13d_tab_link').parent().remove()
      jQuery('#schedule13d_tab').remove()
      return
    }

    var c = [
      { field: 'form_type', index: 'form_type', formatter: whalewisdom.Filer.sch13_link_formatter, title: 'View Record', sortable: false },
      { field: 'name', index: 'name', title: 'Subject Company', sortable: false },
      { field: 'symbol', index: 'symbol', title: 'Symbol', sortable: false },
      { field: 'filed_as_of_date', index: 'filed_as_of_date', title: 'Date of Filing', sortable: false },
      { field: 'event_date', index: 'event_date', title: 'Event Date', sortable: false },
      { field: 'total_reported_shares', index: 'total_reported_shares', sortable: false, title: 'Total Report<br/>Shares Owned' }
    ]
    var names = ['View Record', 'Subject Company', 'Symbol', 'Date of Filing', 'Event Date', 'Total Report<br/>Shares Owned']
    $('#schedule13d_table').bootstrapTable({
      url: whalewisdom.Filer.build_sch13d_url(),
      sidePagination: 'server',
      pagination: true,
      sortName: 'event_date',
      sortOrder: 'desc',
      pageSize: 25,
      rowStyle: function (row, index) {
        return {
          css: { 'padding': '8px', 'height': '37px' }
        }
      },
      checkOnInit: true,
      toggle: 'table',
      showColumns: true,
      pageList: [10, 25, 50],
      totalField: 'records',
      columns: c
    })
  },
  build_sch13d_url: function () {
    return '/schedule13d/holdings/' + whalewisdom.Filer.filer_id
  },
  setup_intl_table: function () {
    if (whalewisdom.Filer.filer_id == undefined) {
      jQuery('#intl_tab_link').parent().remove()
      jQuery('#intl_tab').remove()
      return
    }

    var c = [{ field: 'name', index: 'name', title: 'Subject Company', sortable: true },
      { field: 'symbol', index: 'symbol', title: 'Symbol', sortable: true},
      { field: 'rank', index: 'rank', sortable: true, title: 'Rank' },
      { field: 'shares_held', index: 'shares_held', sortable: true, title: 'Shares Held', formatter: whalewisdom.Filer.format_number },
      { field: 'pct_portfolio', index: 'pct_portfolio', sortable: true, title: '% Portfolio', formatter: whalewisdom.Filer.format_percent },
      { field: 'pct_share_outstanding', index: 'pct_shares_outstanding', sortable: true, title: '% Shares Outstanding', formatter: whalewisdom.Filer.format_percent },
      { field: 'market_value', index: 'market_value', sortable: true, title: 'Market Value', formatter: whalewisdom.Filer.format_money },
      { field: 'holdings_date', index: 'holdings_date', title: 'Date', sortable: true },
      { field: 'filing_type', index: 'filing_type', title: 'Source', sortable: true },
      { field: 'change_shares', index: 'change_shares', title: 'Change in Shares', sortable: true,formatter: whalewisdom.Filer.global_percent_change_formatter },
      { field: 'change_value', index: 'change_value', title: 'Change in Value', sortable: true,formatter: whalewisdom.Filer.global_percent_change_formatter },
      { field: 'change_pct', index: 'change_pct', title: 'Change in % Port.', sortable: true,formatter: whalewisdom.Filer.global_percent_change_formatter },
    ]
   // var names = ['View Record', 'Subject Company', 'Symbol', 'Date of Filing', 'Event Date', 'Total Report<br/>Shares Owned']
    $('#intl_table').bootstrapTable({
      url: whalewisdom.Filer.build_intl_url(),
      sidePagination: 'server',
      pagination: true,
      sortName: 'rank',
      sortOrder: 'asc',
      pageSize: 25,
      /*rowStyle: function (row, index) {
        return {
          css: { 'padding': '8px', 'height': '37px' }
        }
      },*/
      checkOnInit: true,
      toggle: 'table',
      showColumns: true,
      pageList: [10, 25, 50],
      totalField: 'records',
      columns: c
    });

    $('#stale_intl_table').bootstrapTable({
          url: whalewisdom.Filer.build_stale_intl_url(),
          sidePagination: 'server',
          pagination: true,
          sortName: 'rank',
          sortOrder: 'asc',
          pageSize: 25,
          /*rowStyle: function (row, index) {
            return {
              css: { 'padding': '8px', 'height': '37px' }
            }
          },*/
          checkOnInit: true,
          toggle: 'table',
          showColumns: true,
          pageList: [10, 25, 50],
          totalField: 'records',
          columns: c
        })
  },
  build_intl_url: function () {
    return '/global/holdings/' + whalewisdom.Filer.filer_id
  },
  build_stale_intl_url: function () {
      return '/global/stale_holdings/' + whalewisdom.Filer.filer_id
    },
  load_sector_chart: function (element) {
    var call_url = '/filer/get_sector_chart_for_filer?filer_id=' + whalewisdom.Filer.filer_id
    $.ajax({
      url: call_url,
      success: function (data) {
        var chartdata = []
        Highcharts.chart(element, {
          chart: {
            type: 'column',
            height: '500',
          //  backgroundColor: '#ffffff'
          },
          credits: {
            enabled: false
          },
          title: null,
          xAxis: {
            // categories: ['Apples', 'Oranges', 'Pears', 'Grapes', 'Bananas']
            type: 'category',
            labels: {
              formatter: function () {
                var d = new Date(this.value)
                var q = 0
                if (d.getMonth() == 2) { q = 1 }
                if (d.getMonth() == 5) { q = 2 } else if (d.getMonth() == 8) { q = 3 } else if (d.getMonth() == 11) { q = 4 }
                var s = 'Q' + q + ' ' + d.getFullYear()
                if (q == 0) { return '' }
                return s
              }
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: 'Sector Percentage'
            },
            visible: false
          },

          tooltip: {
            formatter: function () {
              var d = new Date(this.key)
              var q = 0
              if (d.getMonth() == 2) { q = 1 }
              if (d.getMonth() == 5) { q = 2 } else if (d.getMonth() == 8) { q = 3 } else if (d.getMonth() == 11) { q = 4 }
              var s = 'Q' + q + ' ' + d.getFullYear()
              return '<b>' + s + '</b><br/>' + this.series.name +
                                ': ' + this.y.toFixed(2) + '%'
            },
            //  pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y.toFixed(2)}</b>',
            shared: false
          },
          plotOptions: {
            column: {
              stacking: 'percent'
            }
          },
          series: data
        })
      },
      cache: false
    })
    /*  d3.json(call_url, function(data) {

            $(element + ' .loading').hide();
            nv.addGraph(function () {
                var chart = nv.models.multiBarChart()//.stackedAreaChart()
                    .margin({right: 30})
                    .x(function (d) {
                            return d[0];
                        }
                    )   //We can modify the data accessor functions...
                    .y(function (d) {
                        if (!d || d=== undefined || d.length<2 || d[1] === undefined){
                            return 0;
                        }
                        return d[1];
                    })   //...in case your data is formatted differently.
                    //  .useInteractiveGuideline(true)    //Tooltips which show all data points. Very nice!
                    .rightAlignYAxis(true)      //Let's move the y-axis to the right side.
                    //  .transitionDuration(500)
                    .stacked(true)
                    //    .showLegend(true)
                    .showYAxis(false)
                    .rotateLabels(0)
                    .groupSpacing(0.1)
                    .reduceXTicks(true)
                    .showControls(false)       //Allow user to choose 'Stacked', 'Stream', 'Expanded' mode.
                    .clipEdge(true);
                //   chart.ticks=10;
                //Format x-axis labels with custom function.
                chart.xAxis
                    .tickFormat(function (d) {
                        var qend = new Date(d);
                        var q = 0;
                        if (qend.getMonth() == 2)
                            q = 1;
                        if (qend.getMonth() == 5)
                            q = 2;
                        else if (qend.getMonth() == 8)
                            q = 3;
                        else if (qend.getMonth() == 11)
                            q = 4;
                        var s = "Q" + q + " " + qend.getFullYear();
                        if (q == 0)
                            return "";
                        return s;//d3.time.format('%Y-%m-%d')(new Date(d[0]));
                        //    return d3.time.format('%x')(new Date(d))
                    });

                chart.yAxis
                    .tickFormat(d3.format('.2%'));

                d3.select(element + ' svg')
                    .datum(data)
                    .call(chart);

                nv.utils.windowResize(chart.update);

                return chart;
            });
        }); */
  },
  view_combined: function (e) {
    /* whalewisdom.Filer.show_combined=!whalewisdom.Filer.show_combined;
        if (whalewisdom.Filer.show_combined){
            jQuery('#cmd-combined-holders').html('Show Historical 13F Holdings Instead');
            $('#combined-heading').css('display','block');
           // $('#quarter_one').css('display','none');
           // $('#qtr-1-label').css('display','none');
            jQuery("#current_holdings_table").showCol(whalewisdom.Filer.columns[11].name);
            jQuery("#current_holdings_table").showCol(whalewisdom.Filer.columns[12].name);
        }
        else
        {
          //  $('#quarter_one').css('display','');
          //  $('#qtr-1-label').css('display','');
            $('#combined-heading').css('display','none');
            jQuery('#cmd-combined-holders').html('Show Current Combined 13F/D/G Portfolio');
            jQuery("#current_holdings_table").hideCol(whalewisdom.Filer.columns[11].name);
            jQuery("#current_holdings_table").hideCol(whalewisdom.Filer.columns[12].name);
        }
        whalewisdom.Filer.refresh(); */
  },
  setup_metric_chart: function () {
    if ($('#filer_metric_chart').length == 0) { return }
    jQuery.ajax({
      url: '/filer/get_current_chart_data?filer_id=' + whalewisdom.Filer.filer_id,
      success: function (data) {
        if (data.length < 4) { return }
        Highcharts.theme = {
          colors: ['#2b908f', '#90ee7e', '#f45b5b', '#7798BF', '#aaeeee', '#ff0066', '#eeaaee',
            '#55BF3B', '#DF5353', '#7798BF', '#aaeeee'],
          chart: {
            backgroundColor: {
              linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
              stops: [
                [0, '#2a2a2b'],
                [1, '#3e3e40']
              ]
            },
            style: {
              fontFamily: '\'Unica One\', sans-serif'
            },
            plotBorderColor: '#606063'
          },
          title: {
            style: {
              color: '#E0E0E3',
              textTransform: 'uppercase',
              fontSize: '20px'
            }
          },
          subtitle: {
            style: {
              color: '#E0E0E3',
              textTransform: 'uppercase'
            }
          },
          xAxis: {
            gridLineColor: '#707073',
            labels: {
              style: {
                color: '#E0E0E3'
              }
            },
            lineColor: '#707073',
            minorGridLineColor: '#505053',
            tickColor: '#707073',
            title: {
              style: {
                color: '#A0A0A3'

              }
            }
          },
          yAxis: {
            gridLineColor: '#707073',
            labels: {
              style: {
                color: '#E0E0E3'
              }
            },
            lineColor: '#707073',
            minorGridLineColor: '#505053',
            tickColor: '#707073',
            tickWidth: 1,
            title: {
              style: {
                color: '#A0A0A3'
              }
            }
          },
          tooltip: {
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            style: {
              color: '#F0F0F0'
            }
          },
          plotOptions: {
            series: {
              dataLabels: {
                color: '#B0B0B3'
              },
              marker: {
                lineColor: '#333'
              }
            },
            boxplot: {
              fillColor: '#505053'
            },
            candlestick: {
              lineColor: 'white'
            },
            errorbar: {
              color: 'white'
            }
          },
          legend: {
            itemStyle: {
              color: '#E0E0E3'
            },
            itemHoverStyle: {
              color: '#FFF'
            },
            itemHiddenStyle: {
              color: '#606063'
            }
          },
          credits: {
            style: {
              color: '#666'
            }
          },
          labels: {
            style: {
              color: '#707073'
            }
          },

          drilldown: {
            activeAxisLabelStyle: {
              color: '#F0F0F3'
            },
            activeDataLabelStyle: {
              color: '#F0F0F3'
            }
          },

          navigation: {
            buttonOptions: {
              symbolStroke: '#DDDDDD',
              theme: {
                fill: '#505053'
              }
            }
          },

          // scroll charts
          rangeSelector: {
            buttonTheme: {
              fill: '#505053',
              stroke: '#000000',
              style: {
                color: '#CCC'
              },
              states: {
                hover: {
                  fill: '#707073',
                  stroke: '#000000',
                  style: {
                    color: 'white'
                  }
                },
                select: {
                  fill: '#000003',
                  stroke: '#000000',
                  style: {
                    color: 'white'
                  }
                }
              }
            },
            inputBoxBorderColor: '#505053',
            inputStyle: {
              backgroundColor: '#333',
              color: 'silver'
            },
            labelStyle: {
              color: 'silver'
            }
          },

          navigator: {
            handles: {
              backgroundColor: '#666',
              borderColor: '#AAA'
            },
            outlineColor: '#CCC',
            maskFill: 'rgba(255,255,255,0.1)',
            series: {
              color: '#7798BF',
              lineColor: '#A6C7ED'
            },
            xAxis: {
              gridLineColor: '#505053'
            }
          },

          scrollbar: {
            barBackgroundColor: '#808083',
            barBorderColor: '#808083',
            buttonArrowColor: '#CCC',
            buttonBackgroundColor: '#606063',
            buttonBorderColor: '#606063',
            rifleColor: '#FFF',
            trackBackgroundColor: '#404043',
            trackBorderColor: '#404043'
          },

          // special colors for some of the
          legendBackgroundColor: 'rgba(0, 0, 0, 0.5)',
          background2: '#505053',
          dataLabelsColor: '#B0B0B3',
          textColor: '#C0C0C0',
          contrastTextColor: '#F0F0F3',
          maskColor: 'rgba(255,255,255,0.3)'
        }

        // Apply the theme

        Highcharts.setOptions(Highcharts.theme)
        var series_data = []

        var s = { name: '13F AUM', data: [], yAxis: 0, type: 'area', visible: true }
        series_data.push(s)

        var s2 = { name: '% Top 10', data: [], yAxis: 1, type: 'line', visible: false }
        series_data.push(s2)

        var s3 = { name: 'Turnover', data: [], yAxis: 1, type: 'line', visible: false }
        series_data.push(s3)

        var s4 = { name: 'Turnover Alt', data: [], yAxis: 1, type: 'column', visible: false }
        series_data.push(s4)
        var s5 = { name: 'Up Months in Down Markets (3-Yr)', data: [], yAxis: 2, type: 'column', visible: false }
        series_data.push(s5)

        var s6 = { name: 'Dividend Yield Top 20 (includes special dividends)', data: [], yAxis: 1, type: 'column', visible: false }
        series_data.push(s6)

        var s7 = { name: 'Performance QoQ', data: [], yAxis: 1, type: 'column', visible: false }
        series_data.push(s7)

        for (var j = 0; j < data.length; j++) {
          var rec = data[j]
          var d =
                        s.data.push({ name: rec.quarter_description, y: rec.total_mv })
          s2.data.push({ name: rec.quarter_description, y: rec.percent_top10 })
          s3.data.push({ name: rec.quarter_description, y: rec.turnover })
          s4.data.push({ name: rec.quarter_description, y: rec.turnover2 })
          s5.data.push({ name: rec.quarter_description, y: rec.up_months_down_markets_eql_three })
          s6.data.push({ name: rec.quarter_description, y: rec.dividend_yield_top20 })
          s7.data.push({ name: rec.quarter_description, y: rec.performance_quarter})
        }
        var y_axis = [
          { title: { text: 'Market Value' },
            opposite: true,
            labels: {
              formatter: function () {
                return numbro(this.value).format('0.0a')
              } } },
          { title: { text: '% Top 10' },
            opposite: false,
            labels: {
              formatter: function () {
                return numbro(this.value / 100.0).format('0.000%')
              } } },
          { title: { text: 'Turnover' },
            opposite: false,
            labels: {
              formatter: function () {
                return numbro(this.value).format('0.000%')
              } } },
          { title: { text: 'Turnover Alt' },
            opposite: false,
            labels: {
              formatter: function () {
                return numbro(this.value).format('0.000%')
              } } },
          { title: { text: 'Up Months in Down Markets (3-Yr)' },
            opposite: false,
            labels: {
              formatter: function () {
                return numbro(this.value).format('0.000%')
              } } },
          { title: { text: 'Dividend Yield Top 20' },
            opposite: false,
            labels: {
              formatter: function () {
                return numbro(this.value / 100.0).format('0.000%')
              } } },
          { title: { text: 'Performance QoQ' },
            opposite: false,
            labels: {
              formatter: function () {
                return numbro(this.value / 100.0).format('0.000%')
              } } }
        ]

        window.whalewisdom.Filer.metrics_chart = Highcharts.chart('filer_metric_chart', {

          title: {
            text: '13F Metrics'
          },

          subtitle: {
            text: ''
          },
          xAxis: {

            type: 'category'
          },

          yAxis: y_axis,
          legend: {
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'bottom'
          },

          plotOptions: {
            series: {
              //   pointStart: 2010
            }
          },
          credits: {
            enabled: false
          },
          tooltip: {
            shared: true,
            crosshairs: [true, true]
          },
          exporting: {
            chartOptions: { // specific options for the exported image
              plotOptions: {
                series: {
                  dataLabels: {
                    enabled: true
                  }
                }
              }
            },
            fallbackToExportServer: false
          },
          chart: {
            // type:'bar',
            zoomType: 'x'
          },

          series: series_data

        })
      }
    })
  },
  build_column_chooser: function () {
    var chooser = $('#holdings-column-chooser')
    var listing = $('#holdings-columns')
    for (var i = 0; i < whalewisdom.Filer.columns.length; i++) {
      var column = whalewisdom.Filer.columns[i]
      //   var ele=$('<li class="list-group-item"></li>')
      if (!column.hidden) { column.hidden = false }
      var chk = $('<button type="button" class="list-group-item">' + (column.hidden ? 'Show ' : 'Hide ') + column.name + '</button>')
      //   var chk=$('<input type=checkbox "'+(column.hidden ? "" : 'checked="checked"')+'"/>');
      chk.data('column', column)
      // ele.append(chk);
      chk.click(function (e) {
        var col = $(this).data('column')

        if (col.hidden) {
          jQuery('#current_holdings_table').jqGrid('showCol', col.name)
          $(this).text('Hide ' + col.name)
          col.hidden = false
        } else {
          jQuery('#current_holdings_table').jqGrid('hideCol', col.name)
          $(this).text('Show ' + col.name)
          col.hidden = true
        }
      })
      listing.append(chk)
    }
    chooser.click(function () {
      listing.toggle()
    })
  }
}

// whalewisdom.Layout.readyEvent.subscribe(whalewisdom.Filer.init);
jQuery(function () {
  whalewisdom.Filer.init()
})
